module.exports = __webpack_public_path__ + "img/map-pin.9bbf70fc.png";